import { render, staticRenderFns } from "./PostItem.vue?vue&type=template&id=06f67e59&scoped=true&"
import script from "./PostItem.vue?vue&type=script&lang=ts&"
export * from "./PostItem.vue?vue&type=script&lang=ts&"
import style0 from "./PostItem.vue?vue&type=style&index=0&id=06f67e59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f67e59",
  null
  
)

export default component.exports